import React, { useContext, useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import 'swiper/css/navigation';
import { Navigation, Pagination, Mousewheel, Keyboard } from "swiper/modules";
import { useFetch } from "../data/fetch/useFetch";
import { parseWidgetData } from "../data/parseWidgetData";
import { classIf, filterBetsByNumberOfOdds, filtraParametriche, getBetDescription, getConfiguration, iconCategoryCssClass, iconSportCssClass } from "../data/utils";
import { usePrematchData } from "../prematch/PrematchDataFetcher";
import PrematchContext from "../contexts/PrematchContext";
import { getFirstLine } from "../common/UOBox";
import Odd from "./Odd";
import SwiperItemsOdd from "./SwiperItemsOdd";
import { getLabel } from "../data/labels";

export const SwiperItems = () => {
    const conf = getConfiguration();
    const [isLoading, isError, data] = useFetch(conf.api.getWidgetCentrali, null, (data) =>
        parseWidgetData(data, false)
    );

    const prematchContext = useContext(PrematchContext);
    const prematchData = usePrematchData();
    const [selectedSport, setSelectedSport] = useState(undefined);
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const chunksRef = useRef(null)
    const currentMarketRef = useRef(null)
    const betsDescs = [];
    const descRef = useRef(null)


    function findFirstValidSport(sports, matchesBySport) {
        return sports.find(sportId => {
            const matches = matchesBySport[sportId] || [];

            return matches.some(m => {
                const [eventHours, eventMinutes] = m.time.split(":").map(Number);
                const now = new Date();
                const nowMinutes = now.getHours() * 60 + now.getMinutes();
                const eventMinutesTotal = eventHours * 60 + eventMinutes;

                return eventMinutesTotal - nowMinutes <= 60 && eventMinutesTotal - nowMinutes >= 0;
            });
        });
    }

    useEffect(() => {
        if (data?.lastMinute?.sports?.length > 0) {
            const firstSport = findFirstValidSport(data?.lastMinute.sports, data?.lastMinute?.matchesBySport);
            if (firstSport) {
                setSelectedSport(firstSport);
            }
        }
    }, [data]);

    const lastMinuteMatches = data?.lastMinute?.matchesBySport?.[selectedSport];

    if (lastMinuteMatches == null) {
        return null;
    }

    function formatDate(dataToFormat) {
        const datePart = dataToFormat.split(' ')[0];
        const year = datePart.substring(0, 4);
        const month = datePart.substring(4, 6);
        const day = datePart.substring(6, 8);
        return `${day}/${month}/${year.substring(2)}`;
    }

    const matches = lastMinuteMatches?.filter(m => {
        const [eventHours, eventMinutes] = m.time.split(":").map(Number);
        const now = new Date();
        const nowHours = now.getHours();
        const nowMinutes = now.getMinutes();
        const diffMinutes = (eventHours * 60 + eventMinutes) - (nowHours * 60 + nowMinutes);

        return diffMinutes <= 60;
    }).map((m, i) => {
        const categoryIcon = iconCategoryCssClass(m.sportRef, m.categoryRef, m.categoryIcon);

        function handleClick() {
            const tournamentUniqueId = `${m.sportRef}_${m.categoryRef}_${m.tournamentRef}`;
            prematchContext.openEvent(tournamentUniqueId, m);
        }

        let bets = filtraParametriche(m.bets);
        bets = filterBetsByNumberOfOdds(bets);
        const newDescription = m.tournamentDesc.split('-')

        const handleSlideChange = (swiper, id) => {
           descRef.current.innerText = swiper.activeIndex;
           document.getElementById(`navigation__description-${m.id}`).innerHTML = bets[swiper.activeIndex].desc;
        };

        return (
            <SwiperSlide key={m.id}>
                <div className="swiper__items--wrapper" >
                    <div className="swiper__items--header">
                        <div className={`swiper__items-tournaments`}> <div className={`ico-sport icoSport${selectedSport}`}></div> <div className="swiper__items-tournaments--team">{newDescription[0]}</div>
                            <div className="swiper__items-tournaments--separator">-</div>
                            <div className="swiper__items-tournaments--team">{newDescription[1]}</div>
                        </div>
                        <div className="swiper__items-eventData"><span>{m.time}</span> <span>|</span> <span>{formatDate(m.timestampDB)}</span></div>
                    </div>
                    <div className="swiper__items__content--wrapper">
                        {/* EVENTNAME*/}
                        <div className="swiper__items__content--eventName">
                            <div className="swiper__items-eventName1">
                                <div className="imgTeam imgTeam-wrapper"> <div className={"imgTeam sport-icon " + categoryIcon}> </div></div><span>{m.team1}</span>
                            </div>
                            <div className="swiper__items-eventNameVS">
                                VS
                            </div>
                            <div className="swiper__items-eventName2">
                                <span>{m.team2} </span> <div className="imgTeam imgTeam-wrapper"><div className={"imgTeam sport-icon " + categoryIcon}></div></div>
                            </div>
                        </div>
                        {/* ODDS */}
                        <div className="odds__carousel">
                            {bets.map((b, betIndex) => {
                                const isParametrica = b.parametrica;
                                if (isParametrica) {
                                    b = getFirstLine(m.betsById.get(b.id));
                                }

                                const oddsDescs = [];
                                const renderedOdds = [];
                                b.odds.forEach(odd => {
                                    if (i === 0) {
                                        oddsDescs.push(
                                            <span key={odd.uniqueId} className="odd-desc">{odd.desc}</span>
                                        );
                                    }

                                    const id = `${m.id}_${odd.id}`;
                                    renderedOdds.push(
                                        <Odd key={odd.uniqueId} data={odd} />
                                    );
                                });

                                let nCols = b.odds.length;
                                if (isParametrica) {
                                    nCols++;
                                }
                                const isEven = betIndex % 2 === 0;
                                return (
                                    <React.Fragment key={b.uniqueId}>
                                    </React.Fragment>
                                );
                            })}

                                

                            <div className="navigation__row">
                                <div id={`navigation__description-${m.id}`} className="navigation__description" ref={descRef}>test</div>
                                <div className="navigation__wrapper">
                                    <div className="navigation-prev" ref={prevRef}></div>
                                    <div className="navigation-pagination" ref={chunksRef}></div>
                                    <div className="navigation-next" ref={nextRef}></div>
                                </div></div>
                            <Swiper
                                modules={[Navigation, Mousewheel, Keyboard, Pagination]}
                                cssMode={true}
                                mousewheel={true}
                                keyboard={true}
                                onSlideChange={(swiper) => handleSlideChange(swiper, `navigation__description-${m.id}`)}
                                pagination={{
                                    type: 'fraction',
                                    el: chunksRef.current,
                                    type: "custom",
                                    renderCustom: (swiper, current, total) => {
                                        return `<span>${current} / ${total}</span>`; // Fraction format
                                    },
                                }}

                                onInit={(swiper) => {
                                    swiper.params.navigation.prevEl = prevRef.current;
                                    swiper.params.navigation.nextEl = nextRef.current;
                                    swiper.navigation.init();
                                    swiper.navigation.update();
                                    swiper.params.pagination.el = chunksRef.current;
                                    swiper.pagination.init();
                                    swiper.pagination.update();
                                    handleSlideChange(swiper, `navigation__description-${m.id}`)
                                }}
                                className="mySwiper"
                            >

                                {bets.map((b, betIndex) => {
                                    const chunkSize = 3;
                                    const chunks = [];
                                    
                                    let group = [];
                                    const isParametrica = b.parametrica;
                                    if (isParametrica) {
                                        b = getFirstLine(m.betsById.get(b.id));
                                    }

                                    const isEven = betIndex % 2 === 0;

                                    b.odds.forEach((z, subIndex) => {
                                        group.push({ data: z, subIndex }
                                        );
                                        if (group.length === chunkSize) {
                                            chunks.push(group);
                                            group = [];
                                        }
                                    });

                                    if (group.length > 0) {
                                        chunks.push(group);
                                    }
                                    if (i === 0) {
                                        betsDescs.push(
                                            <span className="bet-desc">{getBetDescription(b, true, m.sportRef)}</span>
                                        );
                                    }

                                 

                                    return chunks.map((group, slideIndex) => (
                                        <SwiperSlide className="swiper__items__content--eventOdds-wrapper" key={`${betIndex}-${slideIndex}`}>

                                            {/* {isParametrica &&
                                            <div className={"bet" + classIf(isEven, 'lighter')}>
                                                <span className="odd">{b.handicapDesc !== '' && b.handicapDesc !== '0' ? b.handicapDesc : <i className="fa fa-lock"></i>}</span>
                                            </div>} */}
                                            {group.map((z, subIndex) => (

                                                <SwiperItemsOdd data={z.data} key={subIndex} />
                                            ))}
                                        </SwiperSlide>
                                    ));
                                })}
                            </Swiper>
                        </div>
                    </div>
                </div>
            </SwiperSlide>
        )
    })

    return (
        <>
            <div className="section-title swiper__wrapper-sse">
                <span className="title">{getLabel('prematch_page.widget.last_minute')}</span>
                <div className="sport-switcher">
                    {/* filtro per mostrare o nascondendere le label con relativi sport in base al timing*/}
                    {data?.lastMinute?.sports.filter(sportId =>
                        findFirstValidSport([sportId], data?.lastMinute?.matchesBySport)
                    ).map(sportId => {
                        function handleClick() {
                            setSelectedSport(sportId);
                        }
                        const sport = prematchData.sportById[sportId];
                        if (sport) {
                            const desc = sport.descrizione;
                            const icoSport = iconSportCssClass(sport.id, sport.iconClass);
                            const count = data.lastMinute?.matchesBySport[sportId].length;

                            return (
                                <div key={sportId} className={"selection-item" + classIf(selectedSport === sportId, 'active')} onClick={handleClick}>
                                    <div className={"icona-sport ico-sport " + icoSport}></div>
                                    <span className="selection-item-desc">{desc}</span>
                                    {/* <div className="counter">{count}</div> */}
                                </div>
                            );
                        }
                        return null;
                    })}
                </div>
            </div>

            <Swiper
                slidesPerView={1}
                spaceBetween={10}
                breakpoints={{
                    640: {
                        slidesPerView: 1,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    1300: {
                        slidesPerView: 3,
                    },
                    1500: {
                        slidesPerView: 4,
                    },
                }}
                modules={[Pagination]}
                className="swiper__items"
            >
                {matches}
            </Swiper>
        </>
    );
};

export default SwiperItems;
